import BroadcastChannelService, { bc } from '@/broadcastChannel/broadcast-channel-service';
import { EVENTS } from '@/broadcastChannel/broadcast-channel.const';

export interface EventHandler {
	[EVENTS.LOGIN]: (params: Record<string, unknown>) => void;
	[EVENTS.LOGOUT]: () => void;
	[EVENTS.SET_USER]: (params: Record<string, unknown>) => void;
}
export const useBroadcastChannel = () => ({
	onEvents: (eventHandler: EventHandler) => {
		bc.onmessage = (ev) => {
			if (ev.data) {
				const payload = BroadcastChannelService.decrypt(ev.data);
				const { eventName, params, PLY_ENV }: { eventName: EVENTS; params: Record<string, unknown>; PLY_ENV: boolean } = payload;
				if (process.env.VUE_APP_PLY_ENV !== PLY_ENV) {
					return;
				}
				eventHandler[eventName]?.(params);
			}
		};
	},
});
